export default __webpack_public_path__ + "static/Photo 2-672f81467c3a79777db5a238ab0c81f0.jpg";